var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainbox",style:({width:_vm.$route.meta.notright?'100%':'100%'})},[_c('recom')],1)}
var staticRenderFns = []

export { render, staticRenderFns }